export enum ChainId {
  MAINNET = 8453,
  TESTNET = 11155111,
}

export const NETWORK_URLS: {
  [chainId in ChainId]: string
} = {
  [ChainId.MAINNET]: `https://mainnet.base.org`,
  [ChainId.TESTNET]: `https://sepolia.infura.io/v3/e1a93b9201f84df6a0863b9efcd50c1a`,
}
